export const GeneralPublicWords = (destinationLang) => {
  return [
    {
      FormKey: 'general-public-to',
      Key: 'تا',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-from',
      Key: 'از',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-history',
      Key: 'تاريخ',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-insurance-type',
      Key: 'نوع بيمه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-search',
      Key: 'جستجو',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-description',
      Key: 'توضيحات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-flat-alert-no-data',
      Key: 'داده ای موجود نیست',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-alert-success-operation',
      Key: 'انجام عملیات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-payable',
      Key: 'قابل پرداخت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-discount',
      Key: 'تخفیف',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-delete',
      Key: 'حذف',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-edit',
      Key: 'ویرایش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-btn-save',
      Key: 'ثبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-btn-cancel',
      Key: 'لغو',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-alert-error',
      Key: 'خطا',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-patient',
      Key: 'بیمار',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-no-national-code-hint',
      Key: 'فاقد کدملی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-time',
      Key: 'زمان',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-sure-alert',
      Key: 'آیا از انجام عملیات اطمینان دارید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-not-found-page',
      Key: 'این مسیر به جایی نمیرسد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-not-found-return',
      Key: 'بازگشت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-continue',
      Key: 'ادامه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-warning-please-wait',
      Key: 'لطفا منتظر بمانید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-add-form-sure',
      Key: 'آیا از ثبت فرم اطمینان دارید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-save-the-form-alert',
      Key: 'ثبت فرم',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-alert-network-error',
      Key: 'خطا در شبکه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-confirmed',
      Key: 'تایید شده',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: 'general-public-label-presence-date',
      Key: 'تاریخ حضور',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-presence-time',
      Key: 'زمان حضور',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-description',
      Key: 'توضیحات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-diagnose',
      Key: 'تشخیص',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-doctors-list',
      Key: 'پزشکان',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: 'general-public-label-un-confirmed',
      Key: 'تایید نشده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-alert-settlement-confirm',
      Key: 'آیا از تسویه اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'general-public-alert-settlement-confirm-delete',
      Key: 'آیا از حذف اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-alert-downloading-manual',
      Key: 'درحال دانلود راهنما',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-login-or-signup',
      Key: 'ورود / ثبت نام',
      DistinitationLanguage: destinationLang,
    },
    // {
    //   FormKey: "general-public-darman-dar-manzel",
    //   Key: "مرکز درمان در منزل دم",
    //   DistinitationLanguage: destinationLang,
    // },
    {
      FormKey: 'general-public-label-file-name',
      Key: 'نام فایل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-file-date',
      Key: 'تاریخ فایل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-file-description',
      Key: 'توضیحات فایل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-select-description',
      Key: 'انتخاب فایل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-preview',
      Key: 'مشاهده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-default-suggestions',
      Key: 'انتخاب پیشفرض',
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: 'general-public-label-clock',
      Key: 'ساعت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-enter-room',
      Key: 'لینک جلسه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-search-based-on',
      Key: 'جستجو بر اساس',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-approve',
      Key: 'تایید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-unapprove',
      Key: 'عدم تایید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-dismiss',
      Key: 'انصراف',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-route-title-get-report-sms',
      Key: 'دریافت گزارش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-doctor',
      Key: 'پزشک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-sarh-hal',
      Key: 'شرح حال',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-label-print',
      Key: 'چاپ',
      DistinitationLanguage: destinationLang,
    },
  ];
};
